/**
 * @module app.cm
 */

import { autoinject } from 'aurelia-framework';
import { ComponentBase } from 'app/shared/lib/essette-site';

@autoinject()
export class MemberDiagnosesPage extends ComponentBase {

    ////****************** Fields and Properties ************************************////
    protected caseId!: string;

    ////****************** Element References ***************************************////


    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(...rest: any[]) {
        super(...rest);
    }

    protected async canActivate(params: { caseId: string }): Promise<boolean> {
        if(!params.caseId) { throw new Error('Missing or invalid caseId parameter'); }

        return true;
    }

    protected async activate(params: { caseId: string }): Promise<void> {
        if(this.caseId !== params.caseId) { this.caseId = params.caseId; }
    }


    ////****************** Events ***************************************************////


    ////****************** Functions ***********************************************////


    ////****************** Service Calls ********************************************////


}
